import React, { useEffect, useRef, useState } from 'react';
import { resizeContainerId } from '../..';
import { canvasContainerId } from '../../../canvas';
import { navContainerId } from '../../../navbar/NavBar';
import { dragWrapperId } from '../FlowContainer';
import { setProjectState } from '@starflow/app/store';
import ZoomBar from '../ZoomBar';
import expendIcon from '../../assets/expend.svg';
import uploadIcon from '../../assets/upload.svg';
import BookIcon from '../../assets/book.svg';
import { setTempState } from '@starflow/app/store';
import { translate } from '@shakkerai/util-i18n';
import { Tooltip } from 'antd';
import UploadWrapper from '../UploadWrapper';

const HandleList = React.memo(({ defH }) => {
  const [isOpen, setIsOpen] = useState(false);
  const isDragging = useRef(false);
  const flowContainer = useRef(null);
  const canvasContainer = useRef(null);
  const navContainer = useRef(null);
  const offsetDistance = useRef(null);
  const dragWrapper = useRef(null);

  useEffect(() => {
    flowContainer.current = document.getElementById(resizeContainerId);
    canvasContainer.current = document.getElementById(canvasContainerId);
    navContainer.current = document.getElementById(navContainerId);
    dragWrapper.current = document.getElementById(dragWrapperId);
  }, [defH]);

  const onMouseDown = () => {
    isDragging.current = true;
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
    offsetDistance.current = event.clientY - flowContainer.current.getBoundingClientRect().top;
  };

  const handleMouseMove = (event) => {
    if (isDragging.current && flowContainer.current && canvasContainer.current && navContainer.current) {
      const fH = window.innerHeight - event.clientY + offsetDistance.current;
      const cH = event.clientY - offsetDistance.current - navContainer.current.clientHeight;
      if (fH <= defH || fH > (window.innerHeight * 1) / 2) return;
      flowContainer.current.style.height = fH + 'px';
      canvasContainer.current.style.height = cH + 'px';
      dragWrapper.current.style.height = fH - 80 + 'px';
    } else {
      // 如果加载异常，可以尝试再次获取dom
      flowContainer.current = document.getElementById(resizeContainerId);
      canvasContainer.current = document.getElementById(canvasContainerId);
      navContainer.current = document.getElementById(navContainerId);
      dragWrapper.current = document.getElementById(dragWrapperId);
    }
  };

  const handleMouseUp = () => {
    isDragging.current = false;
    document.removeEventListener('mousemove', handleMouseMove);
    document.removeEventListener('mouseup', handleMouseUp);
  };

  const closePreset = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    window.addEventListener('click', closePreset);
    return () => {
      window.removeEventListener('click', closePreset);
    };
  }, []);

  const openPresetModal = (e) => {
    e.stopPropagation();
    setTempState({ exclusiveWindow: 'preset-flow' });
    setIsOpen(false);
  };

  return (
    <>
      <div className="h-[28px] relative bg-[#F4F6F8] flex items-center border-t-[1px] border-b-[1px] border-[#EBEBEB]">
        <div
          className="w-full h-[6px] absolute -top-[3px] cursor-ns-resize"
          onDragStart={(e) => e.preventDefault()}
          onMouseDown={() => onMouseDown()}
        ></div>
        <div className="w-[90px] h-full text-[#2d2d2d] text-center flex items-center justify-center">
          <span className="mr-1">{translate('flow_g_flow')}</span>
          <span>
            <img
              src={expendIcon}
              alt="expend"
              className="w-[16px] h-[16px] cursor-pointer"
              onClick={() => setProjectState({ isFoldFlow: true })}
            />
          </span>
        </div>
        <div className="h-full w-[80px] flex justify-evenly items-center border-l-[1px] border-r-[1px] border-[#EBEBEB]">
          <Tooltip
            open={isOpen}
            trigger="click"
            placement="topLeft"
            overlayInnerStyle={{ padding: 0, borderRadius: '2px', backgroundColor: '#282828' }}
            title={<UploadWrapper setIsOpen={setIsOpen} />}
            arrow={false}
          >
            <img
              src={uploadIcon}
              alt="open"
              className="w-[16px] h-[16px] cursor-pointer"
              onClick={(e) => (e.stopPropagation(), setIsOpen(true))}
            />
          </Tooltip>
          <img
            src={BookIcon}
            alt="upload"
            className="w-[16px] h-[16px] cursor-pointer"
            onClick={(e) => openPresetModal(e)}
          />
        </div>
        <ZoomBar />
      </div>
    </>
  );
});

export default HandleList;
